module.exports = __webpack_public_path__ + "static/media/banner-bg.d6c85438.jpg";